import useLoginDetector from './use-login-detector';

export default useLoginDetector;
